import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@stitches/react';

// 区块容器样式
const SectionContainer = styled('section', {
  width: '100%',
  padding: 'var(--spacing-xxl) 0',
  backgroundColor: 'var(--primary-dark)',
  color: 'white'
});

// 内容容器样式
const ContentContainer = styled('div', {
  maxWidth: 'var(--container-width)',
  margin: '0 auto',
  padding: '0 var(--spacing-lg)'
});

// 成就展示容器样式
const AchievementsContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  
  '@media (min-width: 768px)': {
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
});

// 成就项样式
const AchievementItem = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  padding: 'var(--spacing-lg) 0',
  
  '&:not(:last-child)': {
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
  },
  
  '@media (min-width: 768px)': {
    padding: '0 var(--spacing-lg)',
    flex: '1',
    borderBottom: 'none',
    
    '&:not(:last-child)': {
      borderRight: '1px solid rgba(255, 255, 255, 0.1)',
      borderBottom: 'none'
    }
  }
});

// 成就标签样式
const AchievementLabel = styled('div', {
  fontSize: 'var(--font-size-sm)',
  color: '#ffffff',
  fontWeight: 'var(--font-weight-medium)',
  textTransform: 'uppercase',
  marginBottom: 'var(--spacing-xs)',
  
  '@media (min-width: 768px)': {
    fontSize: 'var(--font-size-md)'
  }
});

// 成就数值样式
const AchievementValue = styled('div', {
  fontSize: '3.5rem',
  fontWeight: 'var(--font-weight-bold)',
  color: '#ffffff',
  lineHeight: 1.2,
  
  '@media (min-width: 768px)': {
    fontSize: '4rem'
  }
});

/**
 * 平台成就部分组件
 * 展示平台的关键数据和成就
 */
const AchievementsSection: React.FC = () => {
  const { t } = useTranslation();
  
  // 成就数据
  const achievements = [
    {
      value: '66,900,000+',
      label: t('home.achievements.totalHashrate')
    },
    {
      value: '20,000+',
      label: t('home.achievements.users')
    },
    {
      value: '300+',
      label: t('home.achievements.nodes')
    }
  ];
  
  return (
    <SectionContainer>
      <ContentContainer>
        <AchievementsContainer>
          {achievements.map((achievement, index) => (
            <AchievementItem key={index}>
              <AchievementLabel>{achievement.label}</AchievementLabel>
              <AchievementValue>{achievement.value}</AchievementValue>
            </AchievementItem>
          ))}
        </AchievementsContainer>
      </ContentContainer>
    </SectionContainer>
  );
};

export default AchievementsSection; 